import conf from '../config/api.js';
import Vue from 'vue';
var moment = require('moment');
//var htmlEncode = require('js-htmlencode').htmlEncode;
var htmlDecode = require('js-htmlencode').htmlDecode;

//Fonction génération de toaster erreur
function toasterError(content, title){
	new Vue().$notify({
        title: title,
        message: content,
        type: 'error',
        position: 'bottom-right'
    })
}

//Fonction génération de toaster réussite
function toasterSuccess(content, title){
	new Vue().$notify({
        title: title,
        message: content,
        type: 'success',
        position: 'bottom-right'
    })
}

//Fonction de synchronisation des produits edox
async function syncCatalogueEdox(){
    try {
        let path = await requestApi({method: 'GET', url: '/api/downloadEdoxCat?nocache=' + new Date().getTime(), params: {}, form: {}, headers: {'Content-Type': 'application/json'}})
        for(const element of path){
            await requestApi({method: 'POST', url: '/api/updateProductEdox?nocache=' + new Date().getTime(), params: {}, form: {path:element.path, type:element.type}, headers: {'Content-Type': 'application/json'}})
        }
    } catch (error) {
        console.log(error)
        toasterError(`Synchronisation impossible`,'Synchronisation')
    }
}

// Fonction appel api
/*
  args: options : method -- required
                  url -- required
                  params -- optional -- url parameters
                  form -- optional -- request body applicable only with PUT, POST and Patch methods
                  headers -- optional
*/
function requestApi (options) {
	return new Promise((resolve, reject) => {
		new Vue().axios({
			method: options.method,
			url: conf.server + options.url,
			params: options.params,
			data: options.form,
			headers: options.headers,
			withCredentials: true
		}).then((response) => {
			resolve(response.data)
		}).catch((error) => {
			reject(error)
		})
	})
}

export default {
    toasterError,
    toasterSuccess,
    syncCatalogueEdox,
}